import Vue from 'vue'
import VueRouter from 'vue-router'
import POSMain from '../views/POSMain.vue'
import KDS from '../views/KDS.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'pos-main',
    component: POSMain
  },
  {
    path: '/kds',
    name: 'KDS',
    component: KDS
  }
]

const router = new VueRouter({
  routes
})

export default router
